import { render, staticRenderFns } from "./MalzemeListesi.vue?vue&type=template&id=e407746e&scoped=true&"
import script from "./MalzemeListesi.vue?vue&type=script&lang=js&"
export * from "./MalzemeListesi.vue?vue&type=script&lang=js&"
import style0 from "./MalzemeListesi.vue?vue&type=style&index=0&id=e407746e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e407746e",
  null
  
)

export default component.exports